import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import toast from "react-hot-toast";

import { useMeetingDetailsStore } from "../../../../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../../../../hooks/useApi";

import { OrgUsersItem } from "./org-users-item";
import { ParticipantItem } from "./participant-item";

export const Sidebar = observer(({ emailForInvite, setEmailForInvite, handleInviteClick, participants, orgUsersList }) => {
  const { inviteParticipant } = useApi();
  const { meeting } = useMeetingDetailsStore();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showInvalidEmailError, updateShowInvalidEmailError] = useState(false);
  const isValidEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
  };

  useEffect(() => {
    if (emailForInvite) {
      const filtered = orgUsersList.filter((user) => user.email.toLowerCase().includes(emailForInvite.toLowerCase()));
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers([]);
    }
  }, [emailForInvite, orgUsersList]);

  const directInvite = (email) => {
    inviteParticipant(meeting.mid, { email }).then((res) => {
      if (res.status === "invited") setEmailForInvite("");
      toast(res.msg);
    });
  };

  const handleInvite = () => {
    if (!isValidEmail(emailForInvite)) {
      updateShowInvalidEmailError(true);
      return;
    }
    updateShowInvalidEmailError(false);
    handleInviteClick();
  };

  return (
    <div className="video-confrance-sidebar">
      <div className="video-confrance-tab-content">
        <div className="h-80 space-between align-items-center m-r-10">
          <div className="relative">
            <input type="text" className="video-confrance-invite" value={emailForInvite} onChange={(e) => setEmailForInvite(e.target.value)} />
            {showInvalidEmailError && <span className="video-confrance-input-error">Please enter a valid email</span>}
          </div>
          <div className="align-items-center">
            <span className="m-lr-10 pointer text-white" onClick={handleInvite}>
              Invite
            </span>
            <span>
              <span className="pointer text-white" onClick={() => setEmailForInvite("")}>
                Cancel
              </span>
            </span>
          </div>
        </div>

        {emailForInvite.length > 0 ? (
          <div className="video-confrance-org-users">
            <p>Org users list</p>
            <ul>
              {filteredUsers.length ? (
                filteredUsers.map((item) => <OrgUsersItem key={item.id} userData={item} directInvite={directInvite} />)
              ) : (
                <li className="justify-content-center align-items-center">
                  <span className="text-center">No matching email among org members</span>
                </li>
              )}
            </ul>
          </div>
        ) : (
          <div className="video-confrance-list-participants">
            {participants.length && <p> Invited</p>}
            <ul>
              {participants
                .slice()
                .sort((a, b) => a.pid - b.pid)
                .map((participant) => (
                  <ParticipantItem key={participant.pid} participant={participant} />
                ))}
            </ul>
            {/* TODO: Commented until we will get useful API or task for this */}
            {/* <div className="video-confrance-inactive-participants"> */}
            {/*  <InactiveParticipants */}
            {/*    inactiveParticipants={inactiveParticipants} */}
            {/*    participants={participants} */}
            {/*    showInactiveParticipants={showInactiveParticipants} */}
            {/*    setShowInactiveParticipants={setShowInactiveParticipants} */}
            {/*  /> */}
            {/* </div> */}
          </div>
        )}
      </div>
    </div>
  );
});
